if (!customElements.get('rc-grease-video')) {
  customElements.define('rc-grease-video', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const playLink = event.target.closest?.('.rc-grease-video__play');
        const id = this.dataset.videoId;
        if (!playLink || !/^[\w-]{11}$/.test(id || '')) return;
        event.preventDefault();
        const iframe = document.createElement('iframe');
        iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(id)}?autoplay=1`;
        iframe.title = this.dataset.videoTitle || 'GreasePak BioCeptor';
        iframe.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        iframe.allowFullscreen = true;
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        this.replaceChildren(iframe);
        iframe.focus();
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
